<!-- 打印加工单 -->
<template>
    <div>
        <div id="printContent" class="print-zone">
            <div class="print-for" v-bind:key="item.TOId" v-for="item in printList">
                <div class="print-title-view">
                    <div class="order-code">
                        <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                        <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                    </div>
                    <div class="print-title">加工单</div>
                    <div class="order-detail">
                        <div class="right">单号：{{ item.PTOCode }}</div>
                        <div class="right">
                            日期：
                            <span>{{ item.CreateTime }}</span>
                        </div>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 10%">调出仓库</div>
                        <div class="div-table-cell fdzt" style="width: 90%">{{ item.OutWarehouseName }}</div>
                    </div>
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 6%">序号</div>
                        <div class="div-table-cell" style="width: 20%">汽配编码</div>
                        <div class="div-table-cell" style="width: 20%">配件名称</div>
                        <div class="div-table-cell" style="width: 20%">车型</div>
                        <div class="div-table-cell" style="width: 14%">出库数</div>
                        <div class="div-table-cell" style="width: 20%">调出仓位</div>
                    </div>
                    <div class="div-table-row" v-for="(AP, index) in tableData" :key="index">
                        <div class="div-table-cell" style="width: 6%">{{ index + 1 }}</div>
                        <div class="div-table-cell" style="width: 20%">{{ AP.APCode }}</div>
                        <div class="div-table-cell" style="width: 20%">{{ AP.GoodName }}</div>
                        <div class="div-table-cell" style="width: 20%">适用:{{ AP.AutoSerise }}</div>
                        <div class="div-table-cell" style="width: 14%">{{ AP.Count + ' ' + AP.Unit }}</div>
                        <div class="div-table-cell" style="width: 20%">{{ AP.GoodsLocation }}</div>
                    </div>
                    <div class="row"></div>
                </div>
                <el-row type="flex" class="order-remark">
                    <el-col :span="24">备注：{{ item.Remark }}</el-col>
                </el-row>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="sort-set">
                    <el-button class="btn-primary" @click="setSortField('sortnum')">原始排序</el-button>
                    <el-button class="btn-primary" @click="setSortField('code')">编码排序</el-button>
                    <el-button class="btn-primary" @click="setSortField('shelfspace')">仓位排序</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: {
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: userMsg.EntpName,
            imgUrl: '',
            tableData: [],
            isPreview: false,
            isDefaultSet: false,
            sortField: ''
        };
    },
    watch: {
        printList(value) {
            this.$nextTick(function () {
                try {
                    let canvas = this.$refs.canva[0];
                    QRCode.toCanvas(
                        canvas,
                        value[0].PTOCode,
                        {
                            width: 80,
                            height: 80,
                            margin: 0,
                            scrollX: 0,
                            scrollY: 0
                        },
                        function (error) {}
                    );

                    setTimeout(() => {
                        html2canvas(canvas, {
                            width: 80,
                            height: 80,
                            scrollX: 0,
                            scrollY: 0
                        }).then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        });
                    }, 1000);
                } catch (e) {
                    //
                }
            });
        }
    },
    created() {
        this.getConfigByCodes();
        let sortField = this.$util.getLocalStorage('trans_print_' + this.userMsg.EmployeeId);
    },
    mounted() {
        this.getTransOrder();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['dyyl', 'syllqdysz'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'dyyl':
                                this.isPreview = result;
                                break;
                            case 'syllqdysz':
                                this.isDefaultSet = result;
                                break;
                        }
                    }
                }
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
.fkyou {
  border-right: 1px solid #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  margin-bottom: 0px;
  font-size: 14px;
}
.fkyou td {
  padding: 0;
  border-right: 1px solid #000;
  border-top: 1px solid #000;
}
.fkyou th {
  padding: 2px;
  border: 1px solid #000;
}

.fkyou div {
  color: #000;
}
.el-row {
  margin-bottom: 0;
}
.print-title-view {
  width: 762px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 12px 0;
}
.order-detail {
  color: #000;
}
.order-code {
    width: 80px;
    height: 80px;
    display: inline-block;
    vertical-align: top;
  }
.qrcode-canvas,.qrcode-image{
      display:none;
  }
.order-remark {
  width: 742px;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 10px;
  margin-right: 10px;
  padding-top: 5px;
  color: #000;
}
.order-setcontent {
  padding: 0px 0px 15px 0px;
  color: #000;
}
.print-title {
   position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 50%;
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #000;
  min-height: 26px;
}
.dialog-footer {
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
}
.print-zone {
  width: 200mm;
  margin-left: 2rpx;
}

.print-table-main {
  width: 762px;
  margin-left: 1px;
  font-size: 12px;
}
.div-table-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: auto;
    line-height: 26px;
    padding-left: 11px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    color: #000;
  }
    .div-table-row {
    display: flex;
    border-left: 1px solid #000;
    margin: 0;
    font-size: 14px;
  }
  .row {
        border-top: 1px solid #000;
    }
.fdzt {
  font-size: 14px;
}
</style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';
                //   LODOP.PRINT_INIT('打印小票')
                LODOP.ADD_PRINT_BARCODE(10, 1, 100, 100, 'QRCode', this.printList[0].PTOCode);
                //   LODOP.PRINT_INIT('打印小票')
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');
                if (this.tableData.length <= 60) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.$util
                .printedRecord({ OrderId: this.printIds[0], Type: 11 }, false)
                .then(() => {})
                .catch(() => {});
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取表格数据
        getTransOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetPrintProcessTransOrderData',
                    data: {
                        PTOId: this.printIds[0],
                        SortField: this.sortField
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.tableData = res.data.DetailList;
                    this.printList.push(res.data);
                });
        },
        setSortField(field) {
            this.$util.setLocalStorage('trans_print_' + this.userMsg.EmployeeId, field);
            this.sortField = field;
            this.tableData = [];
            this.printList = [];
            this.imgUrl = '';
            this.getTransOrder();
        }
    }
};
</script>
<style lang="less">
.fkyou {
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-bottom: 0px;
}
.fkyou td {
    padding: 0;
    border-right: 1px solid #000;
    border-top: 1px solid #000;
}
.fkyou th {
    padding: 0;
    border: 1px solid #000;
}

.fkyou div {
    color: #000;
}
</style>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 5px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 11px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
        margin: 0;
    }
    .row {
        border-top: 1px solid #000;
    }
}
.btn-ctn-left {
    display: flex;
}
.fullCut {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fdzt {
    font-size: 14px;
}
</style>
